export default "__VITE_ASSET__Eb3i80kj__"